<ng-container *ngIf="isLilateAvailable()===true">
    <div class="text-xl font-semibold leading-tight">
        <div class="flex text-xl text-center mt-5" translate [translateParams]="{language:lilate.language.label}">
            lilate-exam.certif.name.1
        </div>
        <div class="flex w-full justify-center mt-5">
            <img class="w-6 h-6 ml-2" src="{{lilate.language.flag}}" alt="language-flag">
        </div>
    </div>
    <div class="font-medium my-5 text-center text-secondary" translate
        [translateParams]="{ date: lilate.start | amLocale: 'fr' | amDateFormat:'DD MMMM YYYY' }">
        lilate-exam.session-content.done-date <span *ngIf="lilate.external_organisation_name" translate
            [translateParams]="{ of: lilate.external_organisation_name }">lilate-exam.orga.name.via</span>
    </div>
    <div class="text-center text-red-500 mb-5"
        *ngIf="lilate && ((lilate.student.user.photo_profile && lilate.student.user.photo_profile.status !== 'validated') || (lilate.identity_issue))"
        translate>
        lilate.dashboard.identityNotValidated
    </div>
    <div class="text-center" *ngIf="!lilate.level_global" translate>
        lilate-exam.session-content.isPendingAssessment
    </div>
    <hr class="w-full border-t my-6">

    <ng-container>
        <div class="grid grid-cols-1 gap-y-4 mt-6">
            <div class="flex items-center">
                <div class="font-medium text-secondary" translate>lilate.dashboard.nextStepsTitle</div>
            </div>
            <div class="flex items-center">
                <mat-icon class="icon-size-5">
                    <svg id="arrow-circle-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                        fill="currentColor">
                        <path fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z"
                            clip-rule="evenodd" />
                    </svg>
                </mat-icon>
                <div class="ml-2" translate>lilate.dashboard.reportingProgress</div>
            </div>
            <div class="flex items-center">
                <mat-icon class="icon-size-5">
                    <svg id="arrow-circle-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                        fill="currentColor">
                        <path fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z"
                            clip-rule="evenodd" />
                    </svg>
                </mat-icon>
                <div class="ml-2" translate>lilate.dashboard.resultEmailInfo</div>
            </div>
        </div>
    </ng-container>
</ng-container>

<ng-container *ngIf="isLilateAvailable()===false">
    <div class="font-bold text-2xl" translate>lilate-exam.session-content.isPendingAssessment</div>
</ng-container>